import { usePerPageValueFromUrl, useSortValueFromUrl } from 'idsk-react-components';
import { SortDirectionEnum } from 'elegislativa-frontend-ts-axios';
import { ClientStatus } from '../../../../model/ClientStatus';
import { useClientFetch } from '../../../../context/ClientStatusContext';
import { defaultPerPageValue, perPageDataArray } from '../../../../constants/PaginationPerPageConstants';
import LegMaterialListFilter from '../../../../model/legislativnyMaterial/LegMaterialListFilter';
import {
  defaultSortPredbezne,
  defaultSortProcesy,
  sortValuesPredbezne,
  sortValuesProcesy,
} from '../../../../constants/SortConstants';
import {
  fetchLegislativnyMaterialFilteredPage,
} from '../../../../client/legislativnyMaterial/legislativnyMaterialFilterListClient';
import LegislativnyMaterialFilterListPage
  from '../../../../model/legislativnyMaterial/LegislativnyMaterialFilterListPage';

interface ReturnType {
  legislativnyMaterialPage: LegislativnyMaterialFilterListPage;
  requestStatus: ClientStatus;
}

const getSort = (sortValue, predbeznaInformacia): string => {
  if (!predbeznaInformacia && !sortValuesProcesy.includes(sortValue)) {
    return defaultSortProcesy;
  }
  if (predbeznaInformacia && !sortValuesPredbezne.includes(sortValue)) {
    return defaultSortPredbezne;
  }
  return sortValue;
};

export default (
  filter: LegMaterialListFilter,
  page: number,
  predbeznaInformacia = false,
): ReturnType => {
  const { perPageValue } = usePerPageValueFromUrl('perPage', perPageDataArray, defaultPerPageValue);
  const { sort } = useSortValueFromUrl();

  const {
    data: legislativnyMaterialPage,
    status: requestStatus,
  } = useClientFetch(
    fetchLegislativnyMaterialFilteredPage,
    [filter, page, perPageValue, getSort(sort[0], predbeznaInformacia),
      sort[1] === 'asc' ? SortDirectionEnum.Asc : SortDirectionEnum.Desc, predbeznaInformacia],
    [page, perPageValue, sort[0], sort[1], JSON.stringify(filter)],
  );

  return {
    legislativnyMaterialPage,
    requestStatus,
  };
};
